// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Q-Nw3","failedIconWrapper":"styles_failedIconWrapper__UpLHK","failedIcon":"styles_failedIcon__CS7Rl"};